import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { GrowthReportResponseSchemaV4 } from "../response/GrowthReportResponseV4";
import { GrowthReportFilterTypeV4 } from "../schema/GrowthReportFilterSchemaV4";

const API_VERSION = 'v4';

interface GrowthReportPropsV4 {
    filter?: GrowthReportFilterTypeV4 | null;
}

const useGrowthReportV4 = (params: GrowthReportPropsV4) => {
    return useQuery({
        queryKey: [
            'report',
            'growth-report',
            'v4',
            JSON.stringify(params.filter) // Kunci cache tetap sama
        ],
        queryFn: async () => {
            // --- PERUBAHAN UTAMA DI SINI ---
            // Mengubah metode dari GET menjadi POST.
            // Filter sekarang dikirim melalui body request sebagai JSON.
            const response = await privateApi.post(`/${API_VERSION}/channel-manager/growth-report`, {
                filter: params.filter
            });
            // --- AKHIR PERUBAHAN ---

            // Logika validasi respons tetap sama dan penting
            const validationResult = GrowthReportResponseSchemaV4.safeParse(response.data.data);
            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid V4 Growth report data format");
            }
            return validationResult.data;
        },
        // Logika untuk mengaktifkan query tidak berubah
        enabled: !!params.filter && !!params.filter.property_id && (params.filter.compare?.length ?? 0) >= 2,
        retry: false,
        refetchOnWindowFocus: false
    });
};

export default useGrowthReportV4;